import { csx } from '@vtex/admin-ui'
import type { ReactElement } from 'react'
import React from 'react'

type AssemblyItemsFooterProps = {
  children: ReactElement
}

export const AssemblyItemsFooter = ({ children }: AssemblyItemsFooterProps) => {
  return (
    <div
      className={csx({
        position: 'sticky',
        bottom: 0,
        width: '100%',
        paddingY: '$space-5',
      })}
    >
      {children}
    </div>
  )
}
